import { useState, useEffect } from "react";
import { ReactComponent as BaseCorp } from "../../assets/icons/companylogo.svg";
import { ReactComponent as SubMenuIcon } from "../../assets/icons/sideBarIcon.svg";
import sidemenucss from "../../css/sidemenu.module.css";
import { useHistory, useParams } from "react-router-dom";
import { GetPayable } from "../../../WorkSpace/Components/ApiServices/apiHandler";

const PayablesSideBar = ({ activeTab, subMenuItem }) => {
  const { id = "", companyId = "" } = useParams();
  const [regName, setRegName] = useState("");
  const [companyName, setCompanyName] = useState("");

  const redirectTo = (link) => {
    window.location.href = link;
  };

  const routerHistory = useHistory();
  const handleClick = (Link) => {
    routerHistory.push(Link);
  };

  const subMenu = () => {
    if (hideUnHideSubMenu === "A") {
      sethideUnHideSubMenu("I");
    } else {
      sethideUnHideSubMenu("A");
    }
  };

  const [hideUnHideSubMenu, sethideUnHideSubMenu] = useState("A");

  useEffect(() => {
    const fetchPayableMeta = async () => {
      try {
        const response = await GetPayable();
        const payableItems =
          response.data?.payables ||
          response.data?.Payable ||
          response.data?.result ||
          [];
        const payableArray = Array.isArray(payableItems)
          ? payableItems
          : [payableItems];
        const selectedPayable =
          payableArray.find(
            (item) =>
              item &&
              (item._id === id ||
                item.id === id ||
                item.payableID === id ||
                item.PayableID === id)
          ) ||
          payableArray[0];

        if (selectedPayable) {
          setRegName(
            selectedPayable.regname ||
              selectedPayable.name ||
              selectedPayable.title ||
              "Payable Register"
          );
          setCompanyName(
            selectedPayable.companyData?.company_name ||
              selectedPayable.companyData?.companyName ||
              selectedPayable.company_name ||
              selectedPayable.companyName ||
              ""
          );
        }
      } catch (error) {
        console.error("Failed to load payable sidebar metadata:", error);
      }
    };

    fetchPayableMeta();
  }, [id]);

  const menuItems = [
    // { key: 1, label: "Overview", pagelink: `/myfinV2/payables/overview/${id}/${companyId}` },
    { key: 1, label: "Listing", pagelink: `/myfinV2/payables/listing/${id}/${companyId}` },
    // {
    //   key: 3,
    //   label: "Compute Calculations",
    //   pagelink: `/myfinV2/payables/computecalculation/${id}/${companyId}`,
      // subMenu: [
      //     { label: "ECL", link: `/myfinV2/receivables/ecl/${id}/${companyId}`},
      // ]
   // },
    // {
    //     key: 3,
    //     label: "Compute Calculations",
    //     // subMenu: [
    //     //     { label: "ECL", link: `/myfinV2/receivables/ecl/${id}/${companyId}`},
    //     // ]
    // },
  ];

  const activeItem = activeTab;
  const activeItemSubMenu = subMenuItem;

  return (
    <div
      className={`${sidemenucss.sidemenuContainer} ${sidemenucss.sidemenuBackgroundClr}`}
    >
      <div className={sidemenucss.sidemenuHeader}>
        <BaseCorp className={sidemenucss.sidemenuCompanyLogoSize} />
        <span className={sidemenucss.sidemenuTitle}>{regName || "Payable Register"}</span>
        <div style={{ textAlign: "left" }}>
          <p className={sidemenucss.companyText} >
            {companyName || "Company"}
          </p>
        </div>
      </div>
      <div
        className={`${sidemenucss.sidemenuContent} ${sidemenucss.sidemenuLinksFontSize} ${sidemenucss.sidemenuContentTop}`}
      >
        <ul className={sidemenucss.sidemenuList}>
          {menuItems.map((item, index) => (
            <div key={index}>
              <li
                onClick={() => {
                  subMenu();
                  if (item.pagelink) {
                    setTimeout(() => handleClick(item.pagelink), 100);
                  }
                }}
                className={`${sidemenucss.sidemenuItem} ${
                  activeItem === item.label
                    ? sidemenucss.sidemenuItemActive
                    : ""
                }`}
              >
                <span className={sidemenucss.sidemenuItemname}>
                  <div className={sidemenucss.sideMenuItemContainer}>
                    {item.label}
                    <div className={sidemenucss.submenuIcon}>
                      {item.subMenu ? (
                        <SubMenuIcon
                          className={`${sidemenucss.submenuIconSvg} ${
                            hideUnHideSubMenu === "A"
                              ? null
                              : sidemenucss.rotatedIcon
                          }`}
                        />
                      ) : null}
                    </div>
                  </div>
                </span>
              </li>
              {item.subMenu ? (
                <div
                  className={`${sidemenucss.submenuContainer} ${
                    hideUnHideSubMenu === "A"
                      ? sidemenucss.sideMenuShow
                      : sidemenucss.sideMenuHide
                  }`}
                >
                  {item.subMenu.map((sub, idx) => (
                    <div
                      key={idx}
                      className={`${sidemenucss.submenuItem} ${
                        activeItemSubMenu === sub.label
                          ? sidemenucss.activeSubMenu
                          : null
                      }`}
                      onClick={() => handleClick(sub.link)}
                    >
                      {sub.label}
                    </div>
                  ))}
                </div>
              ) : null}
            </div>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default PayablesSideBar;
